import React, { CSSProperties } from "react";

const OuterDraggableCSSProperties = (
  start: number,
  span: number,
  marginTop: number,
  cellWidth: any
): CSSProperties => {
  return {
    top: marginTop,
    left: `${(start - 1) * cellWidth}px`,
    width: `${span * cellWidth}px`,
    height:"30px",
    zIndex: 2,
  };
};

export default OuterDraggableCSSProperties;
